var map = {
	"./bangkok.jpg": 112,
	"./delhi.jpg": 344,
	"./dubai.jpg": 751,
	"./hongkong.jpg": 260,
	"./istanbul.jpg": 761,
	"./kualalumpur.jpg": 938,
	"./london.jpg": 924,
	"./macau.jpg": 423,
	"./paris.jpg": 756,
	"./readme.png": 783,
	"./singapore.jpg": 774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;